import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index/index";
import Regist from "../views/regist/regist";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
  },
  {
    path: "/regist",
    name: "Regist",
    component: Regist,
  },
];

const router = new VueRouter({
  routes,
  mode :"history"
});

export default router;
